import { render, staticRenderFns } from "./checkDesign.vue?vue&type=template&id=4ab161ab"
import script from "./checkDesign.vue?vue&type=script&lang=js"
export * from "./checkDesign.vue?vue&type=script&lang=js"
import style0 from "./checkDesign.vue?vue&type=style&index=0&id=4ab161ab&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports